export function normalizeOptions(options) {
  return (options ?? []).map((opt) => ({
    value: opt?.value,
    label: String(opt?.label ?? opt?.value ?? ''),
    disabled: Boolean(opt?.disabled),
  }));
}

export function findOptionIndex(options, value) {
  return options.findIndex((opt) => opt.value === value);
}
